<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="发送方联系人姓名" name="senderContact">
                        <a-input style="width:100%" v-model:value="form.senderContact" placeholder="请输入发送方联系人姓名" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="发送方联系人电话" name="senderContactNumber">
                        <a-input style="width:100%" v-model:value="form.senderContactNumber" placeholder="请输入发送方联系人电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="接收方联系人姓名" name="receiveContact">
                        <a-input style="width:100%" v-model:value="form.receiveContact" placeholder="请输入接收方联系人姓名" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="接收方联系人电话" name="receiveContactNumber">
                        <a-input style="width:100%" v-model:value="form.receiveContactNumber" placeholder="请输入接收方联系人电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="已获投资金额" name="investAmount">
                        <a-input style="width:100%" v-model:value="form.investAmount" placeholder="请输入已获投资金额" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="拟投资金额" name="planInvestAmount">
                        <a-input style="width:100%" v-model:value="form.planInvestAmount" placeholder="请输入拟投资金额" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="对接类型（1企业联系投资人，2投资人联系企业, 3 线下,4企业联系投资机构的投资经理,5投资机构投资经理联系企业）" name="dockingType">
                        <a-input style="width:100%" v-model:value="form.dockingType" placeholder="请输入对接类型（1企业联系投资人，2投资人联系企业, 3 线下,4企业联系投资机构的投资经理,5投资机构投资经理联系企业）" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="审核状态：0 待审核，1 审核通过，2 审核未通过" name="auditStatus">
                        <a-input style="width:100%" v-model:value="form.auditStatus" placeholder="请输入审核状态：0 待审核，1 审核通过，2 审核未通过" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="接收状态 0 未读 1 已读" name="receiveState">
                        <a-input style="width:100%" v-model:value="form.receiveState" placeholder="请输入接收状态 0 未读 1 已读" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="批注" name="feedback">
                        <a-input style="width:100%" v-model:value="form.feedback" placeholder="请输入批注" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="对接备注" name="notes">
                        <a-input style="width:100%" v-model:value="form.notes" placeholder="请输入对接备注" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="线下业务备注" name="otherNotes">
                        <a-input style="width:100%" v-model:value="form.otherNotes" placeholder="请输入线下业务备注" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="备注" name="remark">
                        <a-textarea v-model:value="form.remark" placeholder="请输入备注"
                            :auto-size="{ minRows: 5, maxRows: 6 }" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeDocking} from "@/api/finance";
import {innovation} from "@/config/variableConfig";

export default {
    name: "AddOrEditModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            innovation,
            form: {
                id: null,
                companyCode: null,
                senderContact: null,
                senderContactNumber: null,
                receiveContact: null,
                receiveContactNumber: null,
                investAmount: null,
                planInvestAmount: null,
                dockingType: null,
                auditStatus: null,
                receiveState: null,
                feedback: null,
                notes: null,
                otherNotes: null,
                remark: null,

            },
            rules: {
                    id: [],
                    companyCode: [],
                    senderContact: [dataCheck.required({})],
                    senderContactNumber: [dataCheck.required({}),dataCheck.phone],
                    receiveContact: [dataCheck.required({})],
                    receiveContactNumber: [dataCheck.required({}),dataCheck.phone],
                    investAmount: [dataCheck.required({})],
                    planInvestAmount: [dataCheck.required({})],
                    dockingType: [dataCheck.required({})],
                    auditStatus: [dataCheck.required({})],
                    receiveState: [dataCheck.required({})],
                    feedback: [dataCheck.required({})],
                    notes: [dataCheck.required({})],
                    otherNotes: [dataCheck.required({})],
                    remark: [dataCheck.required({})]
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeDocking.edit
                } else {
                    return financeDocking.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
